import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import Place from '@mui/icons-material/Place';
import { useNavigate } from 'react-router-dom';
import { eventImageUrl } from '../api/files';
import { formatTime } from '../utils/format';
import { EventStatusChip } from './EventStatusChip';
import type { EventInfo } from '../api/types';

export function EventCard({ event }: { event: EventInfo }) {
    const navigate = useNavigate();
    const image = eventImageUrl(event.event_image);

    return (
        <Card className="h-full overflow-hidden bg-white/5 backdrop-blur" elevation={0}>
            <CardActionArea
                onClick={() => navigate(`/event/${event.event_id}`)}
                className="flex h-full flex-col"
            >
                <div className="relative h-44 w-full shrink-0">
                    <img
                        src={image}
                        alt={event.event_title}
                        className="h-full w-full object-cover object-center"
                        loading="lazy"
                    />
                    <EventStatusChip eventDate={event.event_date} className="absolute right-2 top-2" />
                </div>
                <CardContent className="flex flex-1 flex-col gap-2">
                    <Typography variant="h6" sx={{ fontWeight: 700 }}>
                        {event.event_title}
                    </Typography>
                    <div className="flex flex-wrap items-center gap-1 text-sm text-gray-300">
                        <CalendarMonth className="text-accent" />
                        {formatTime(event.event_date)}
                    </div>
                    {event.event_location && (
                        <div className="flex items-center gap-1 text-sm text-gray-300">
                            <Place className="text-accent" />
                            {event.event_location}
                        </div>
                    )}
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
